export default __webpack_public_path__ + "static/media/svg.73446d92.svg";